import React from 'react';
import { ArrowRight, Leaf, Beef, Wheat } from 'lucide-react';
export function UniqueMechanism() {
  return <section className="py-20 bg-green-900 text-white overflow-hidden relative" data-id="element-197">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-198"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-199">
        <div className="max-w-4xl mx-auto text-center" data-id="element-200">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-green-50" data-id="element-201">
            El Protocolo del Orden Metabólico
          </h2>

          <p className="text-xl md:text-2xl text-green-100 mb-12 leading-relaxed font-medium" data-id="element-202">
            No se trata de "qué" come, sino de{' '}
            <span className="text-orange-400 font-bold underline decoration-orange-400 decoration-4 underline-offset-4" data-id="element-203">
              "cómo" lo come.
            </span>
          </p>

          <p className="text-lg text-green-50 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-204">
            Este método utiliza una técnica de secuenciación de alimentos que
            crea un "colchón" gástrico. Al ingerir los alimentos en el orden
            correcto, usted puede disfrutar de su comida tradicional mientras
            mantiene sus niveles de azúcar estables, eliminando la fatiga
            post-comida de inmediato.
          </p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-205">
            <div className="bg-green-800/80 border border-green-700 p-6 rounded-2xl w-full md:w-64 flex flex-col items-center shadow-xl" data-id="element-206">
              <div className="bg-green-100 p-4 rounded-full mb-4" data-id="element-207">
                <Leaf className="w-8 h-8 text-green-700" data-id="element-208" />
              </div>
              <span className="text-xl font-bold" data-id="element-209">1. Fibra</span>
            </div>

            <ArrowRight className="w-8 h-8 text-orange-400 hidden md:block" data-id="element-210" />
            <ArrowRight className="w-8 h-8 text-orange-400 rotate-90 md:hidden my-2" data-id="element-211" />

            <div className="bg-green-800/80 border border-green-700 p-6 rounded-2xl w-full md:w-64 flex flex-col items-center shadow-xl" data-id="element-212">
              <div className="bg-orange-100 p-4 rounded-full mb-4" data-id="element-213">
                <Beef className="w-8 h-8 text-orange-700" data-id="element-214" />
              </div>
              <span className="text-xl font-bold" data-id="element-215">2. Proteína</span>
            </div>

            <ArrowRight className="w-8 h-8 text-orange-400 hidden md:block" data-id="element-216" />
            <ArrowRight className="w-8 h-8 text-orange-400 rotate-90 md:hidden my-2" data-id="element-217" />

            <div className="bg-green-800/80 border border-green-700 p-6 rounded-2xl w-full md:w-64 flex flex-col items-center shadow-xl" data-id="element-218">
              <div className="bg-yellow-100 p-4 rounded-full mb-4" data-id="element-219">
                <Wheat className="w-8 h-8 text-yellow-700" data-id="element-220" />
              </div>
              <span className="text-xl font-bold" data-id="element-221">3. Carbohidrato</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}